function applyCardNameOverride(card, nameOverrides) {
  const overrideName = nameOverrides?.[card.id]?.trim();
  return overrideName ? { ...card, label: overrideName } : card;
}

function applyCardStyleOverride(card, styleOverrides) {
  const overrideStyle = styleOverrides?.[card.id]?.trim();
  return overrideStyle ? { ...card, style: overrideStyle } : card;
}

function applyCardOverrides(card, nameOverrides, styleOverrides) {
  return applyCardStyleOverride(
    applyCardNameOverride(card, nameOverrides),
    styleOverrides
  );
}

function isNotIssuedStatus(status) {
  return status === 'not_issued' || status === 'pending';
}

function isActivatingStatus(status) {
  return status === 'activating';
}

function isIssueFundingCovered(card) {
  return Boolean(card?.issueFundingCovered);
}

export function buildCarouselCards(
  cards = [],
  nameOverrides = {},
  styleOverrides = {},
  cardCopy = {}
) {
  return cards.map((card) => {
    const fundingProgress = card.issueFundingProgress || {};
    const shouldShowIssueProgress = isNotIssuedStatus(card.status)
      && !isIssueFundingCovered(card)
      && fundingProgress.hasProgress;
    const carouselCard = applyCardOverrides({
      ...card,
      style: styleOverrides[card.id]?.trim() || card.style,
      label: isNotIssuedStatus(card.status)
        ? card.name?.trim() || card.label || cardCopy.pendingCard || 'Pending card'
        : isActivatingStatus(card.status)
          ? nameOverrides[card.id]?.trim()
            || card.name?.trim()
            || card.label
            || cardCopy.activatingTitle
            || cardCopy.pendingCard
            || 'Issuing card'
          : nameOverrides[card.id]?.trim() || card.name?.trim() || card.label || cardCopy.main || 'Main',
      balance: card.balance,
      detailsText: isActivatingStatus(card.status)
        ? cardCopy.activatingIssue || ''
        : isNotIssuedStatus(card.status)
          ? isIssueFundingCovered(card)
            ? cardCopy.issuePaymentReceivedTitle || ''
            : cardCopy.topUpToActivate || ''
          : '',
    }, nameOverrides, styleOverrides);

    if (!shouldShowIssueProgress) {
      return carouselCard;
    }

    return {
      ...carouselCard,
      label: cardCopy.completeActivation || cardCopy.topUpToActivate || 'Complete activation',
      detailsText: `${fundingProgress.receivedLabel} / ${fundingProgress.requiredLabel}`,
    };
  });
}
